<template>
    <v-main class="pa-2" fluid>
        <h1>Addons</h1>
        <v-row>
            <v-dialog v-model="dialog" @keydown.esc="dialog = false" persistent max-width="600px">
                <template v-slot:activator="{ on }">
                    <v-btn color="primary" dark v-on="on">Add new Addon</v-btn>
                </template>
                <v-card color="lighten-1">
                    <v-toolbar>
                        <v-toolbar-title>
                            <span class="headline">New Addon</span>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-form ref="form" v-model="valid" class="row">
                                    <v-col cols="12" md="12">
                                        <v-text-field label="Name" v-model="editedItem.name" :rules="nameRules" required></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="12">
                                        <v-text-field label="Price" v-model="editedItem.price"  :rules="priceRules" required></v-text-field>
                                    </v-col>
                                </v-form>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="dialog = false">Cancel</v-btn>
                        <v-btn color="blue darken-1" type="submit" @click="save" :disabled="!valid">Save</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>

        <v-data-table
            :headers="headers"
            :items="addons"
            :items-per-page="20"
            class="elevation-1">
                <template v-slot:item.actions="{ item }">
                    <v-btn icon small @click="edit(item)">
                      <v-icon center>mdi-pencil</v-icon> 
                    </v-btn>
                    
                    <!-- <v-btn icon small color="red" @click="deleteMerch(item.id)">
                      <v-icon center>mdi-delete-forever</v-icon> 
                    </v-btn> -->
                </template>
            </v-data-table>
    </v-main>
</template>

<script>
    import { mapState } from 'vuex'

    export default {
        data() {
            return {
                headers: [
                    { text: '', value: 'data-table-expand' },
                    { text: 'Name', align: 'start', sortable: true, value: 'name', },
                    { text: 'Price', align: 'start', sortable: true, value: 'price', },
                    { text: '', align: 'start', sortable: true, value: 'actions', },
                ],

                dialog: false,
                editedIndex: -1,
                valid: true,
                lazy: true,
                isEditing: null,
                editedIndex: -1,

                editedItem : {
                    'name': '',
                    'price': '',
                    'category' : 'addons'
                },
                nameRules: [
                    v => !!v || 'Name is required',
                ],
                priceRules: [
                    v => !!v || 'Price is required',
                ],
            }
        },

        mounted () {
            this.$store.dispatch('fetchAddons')
        },


        computed: {
            ...mapState(['addons']),

            formTitle () {
                return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
            },
        },

        watch: {
            dialog (val) {
                
                val || this.close()
            },
        },
        
        methods: {

            close () {
                this.dialog = false
                this.$nextTick(() => {
                  this.editedItem = Object.assign({}, this.defaultItem)
                  this.editedIndex = -1
                  
                })
              },

            edit(item) { 

                this.editedIndex = this.addons.indexOf(item);
                this.editedItem = Object.assign({}, item)

                this.dialog = true
            },


             save () {

                if (this.editedIndex > -1) {


                    axios.put('/api/merch/' + this.editedItem.id, this.editedItem)
                        .then( response => {

                            Object.assign(this.addons[this.editedIndex], this.editedItem)
                            this.close();
                            
                        })
                        .catch( err => {
                            console.log( err )
                        })

                  
                } else {


                    axios.post('/api/merch', this.editedItem)
                    .then( response => {

                        this.addons.push(this.editedItem)

                        this.close();
                        
                    })
                    .catch( err => {
                        console.log( err )
                    })
                  
                }

              },


            deleteMerch(id) {
                confirm('Are you sure you want to delete this Item? This action can not be undone') && 

                axios.delete('/api/merch/' + id)
                        .then( response => {

                            const index = this.addons.map(function (f) { return f.id }).indexOf(id)

                            // this.$store.state.merch.splice(index, 1)
                            this.addons.splice(index, 1)
                        })
                        .catch( err => {
                            console.log( err )
                        })
              }

        }
    }
</script>